<template>
  <mock-up-main>
    <floating-btn
      v-if="value.socialMedia && Object.keys(value.socialMedia).length > 0"
      v-model="value.socialMedia"
      class="position-absolute"
      style="top: 15px; right: 15px; z-index: 20;"
    />
    
    <component
      :is="components[value?.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >
      <div
        v-if="showWelcome && value.photo?.hasWelcome"
        class="col-md-11 bg-white mx-auto d-flex"
        style="min-height: 80vh"
        key="loading"
      >
        <div class="col m-auto" v-if="value?.photo?.welcome === ''">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </div>
        <div class="m-auto" v-if="value.photo?.welcome !== ''">
          <img
            class="bg-white img-fluid rounded-circle mx-auto my-auto"
            width="100"
            :src="value.photo.welcome"
            alt=""
          />
        </div>
      </div>
      
      <v-card
        light
        flat
        class="overflow-y-auto rounded-lg view-wrapper px-0"
        max-height="660"
        style="height: calc(100%); position: relative; z-index: 1;"
        :style="{
          background: backgroundImage ? `url(${backgroundImage}) no-repeat center center / cover` :value?.baseInfo?.sectionColor?.backGround || 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          color: value?.baseInfo?.sectionColor?.text || '#333333'
        }"

      >
             <div v-if="backgroundImage" class="bg-overlay"></div>
        <b-intro-slider-view
          v-if="value.banner?.gallery?.length > 0"
          v-model="computedBanner"
          :is-slider="false"
          type="banner"
        />

        <view-social v-model="value" />
        
        <div style="height: 200px; width: 100%; display: block; clear: both;"></div>
      </v-card>
    </component>

    <div class="modern-footer-wrapper" :style="{
      background: value.baseInfo?.sectionColor?.backGround || 
                 'linear-gradient(90deg, #780206 0%, #061161 100%)',
      color: value.baseInfo?.sectionColor?.text || 'white'
    }">
      <div class="footer-content px-4 pb-4">
        <v-btn
          block
          rounded
          
          :loading="vcfLoading"
          :class="['elevation-8 glass-effect', { 'active-btn': showMedia }]"   
          :style="{
            background: value.baseInfo?.sectionColor?.backGround || 
                       'linear-gradient(90deg, #780206 0%, #061161 100%)',
            color: value.baseInfo?.sectionColor?.text || 'white'
          }"
          class="elevation-8 py-0"
          @click="getVcf"
        >
          <v-icon right class="ml-2">mdi-account-plus</v-icon>         
          ذخیره در مخاطبین
        </v-btn>
        <div class="d-flex justify-center align-center mt-3" style="font-size: 10px; gap: 8px;" @click="openLink">
          <img src="media/cr_logo.webp" alt="Terminal Ads" style="height: 33px; object-fit: contain;" />
          <span>قدرت گرفته از کیوآر لند</span>
        </div>
      </div>
    </div>
  </mock-up-main>
</template>

<script>
import BIntroSliderView from "../../../../pages/businessPage/components/view/bIntroSliderView";
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import FloatingBtn from "./floatingBtn";
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import { Bus } from "@/main";
import VideoCardView from "@/view/pages/otherQrTypes/videoGallery/components/videoCardView";
import ViewSocial from "@/view/pages/otherQrTypes/socialMedia/component/viewSocial";
import MockUpMain from "../../../businessPage/components/mockUp";
import { AtomSpinner } from "epic-spinners"; // در صورت استفاده در تمپلیت باید ایمپورت شود

export default {
  name: "socialMobile",
  components: {
    MockUpMain,
    ViewSocial,
    VideoCardView,
    GallerySlider,
    ViewPage,
    FloatingBtn,
    BGalleryView,
    ShowInfo,
    BIntroSliderView,
    AtomSpinner,
  },
  props: {
    value: {},
  },
  data() {
    return {
      vcfLoading: false,
      showWelcome: false,
      showMedia: false, // اضافه شده برای کارکرد کلاس‌های فوتر
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
  computed: {
    backgroundImage() {
      const firstGallery = this.value?.photo?.headBackground;
        return firstGallery;      
    },
    computedBanner: {
      get() {
          if (this.value?.banner?.gallery?.[0]?.images?.length > 0)
          return {
            banner: this.value?.banner?.gallery?.[0],
          };
        else {
          return null;
        }
      },
    },
  },
  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
      }
    });
  },
  methods: {
  openLink(){
    window.open('https://qrland.ir', '_blank');
    },
    getVcf() {
      if (!this.value) return;
      this.vcfLoading = true;
      const rawData = this.value.data ? this.value.data : this.value;

      try {
        const escapeVCardValue = (value = "") => {
          return String(value)
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "")
            .replace(/,/g, "\\,")
            .replace(/;/g, "\\;");
        };

        const foldLine = (line, maxLength = 75) => {
          if (line.length <= maxLength) {
            return line;
          }
          let result = "";
          while (line.length > maxLength) {
            result += line.slice(0, maxLength) + "\r\n ";
            line = line.slice(maxLength);
          }
          result += line;
          return result;
        };

        const addLine = (arr, line) => {
          arr.push(foldLine(line));
        };

        const socialPlatforms = {
          instagram: { label: "Instagram", url: "https://instagram.com/" },
          telegram: { label: "Telegram", url: "https://t.me/" },
          whatsapp: { label: "WhatsApp", url: "https://wa.me/" },
          linkedin: { label: "LinkedIn", url: "https://linkedin.com/in/" },
          twitter: { label: "Twitter", url: "https://twitter.com/" },
          x: { label: "X", url: "https://x.com/" },
          facebook: { label: "Facebook", url: "https://facebook.com/" },
          youtube: { label: "YouTube", url: "https://youtube.com/@" },
          github: { label: "GitHub", url: "https://github.com/" },
          tiktok: { label: "TikTok", url: "https://tiktok.com/@" },
          pinterest: { label: "Pinterest", url: "https://pinterest.com/" },
          twitch: { label: "Twitch", url: "https://twitch.tv/" },
          aparat: { label: "Aparat", url: "https://aparat.com/" },
          eitaa: { label: "Eitaa", url: "https://eitaa.com/" },
          bale: { label: "Bale", url: "https://ble.ir/" },
          rubika: { label: "Rubika", url: "https://rubika.ir/" },
          soroush: { label: "Soroush+", url: "https://splus.ir/" },
          gap: { label: "Gap", url: "https://gap.im/" },
          igap: { label: "iGap", url: "https://igap.net/" },
          virgool: { label: "Virgool", url: "https://virgool.io/@" }
        };

        const normalizeSocialLink = (platform, value) => {
          value = String(value).trim();
          if (value.startsWith("http://") || value.startsWith("https://")) {
            return value;
          }
          if (value.startsWith("skype:")) {
            return value;
          }
          if (platform === "whatsapp") {
            const phone = value.replace(/[^\d]/g, "");
            return `https://wa.me/${phone}`;
          }
          const config = socialPlatforms[platform];
          if (config) {
            return config.url + value.replace(/^@/, "");
          }
          return `https://${value}`;
        };

        let vcard = [];
        addLine(vcard, "BEGIN:VCARD");
        addLine(vcard, "VERSION:3.0");
        addLine(vcard, "PRODID:-//Digital Card//FA//EN");

        const name = rawData?.organizationName || rawData?.visitName || "مخاطب جدید";
        addLine(vcard, `N;CHARSET=UTF-8:;${escapeVCardValue(name)};;;`);
        addLine(vcard, `FN;CHARSET=UTF-8:${escapeVCardValue(name)}`);

        if (rawData?.organizationName) {
          addLine(vcard, `ORG;CHARSET=UTF-8:${escapeVCardValue(rawData.organizationName)}`);
        }
        if (rawData?.website) {
          addLine(vcard, `URL:${escapeVCardValue(rawData.website)}`);
        }

        let notesArray = [];
        if (rawData?.aboutUs) {
          notesArray.push(rawData.aboutUs);
        }

        let itemIndex = 1;
        if (rawData?.socialMedia) {
          const sm = rawData.socialMedia;
          for (const [platform, items] of Object.entries(sm)) {
            if (!Array.isArray(items)) continue;
            for (const item of items) {
              if (!item?.url) continue;
              const lowerPlatform = platform.toLowerCase();
              let value = String(item.url).trim();

              if (["phone", "mobile", "call"].includes(lowerPlatform)) {
                const cleanPhone = value.replace(/[^\d+]/g, "");
                addLine(vcard, `TEL;TYPE=CELL,VOICE:${cleanPhone}`);
                continue;
              }

              if (lowerPlatform === "whatsapp") {
                const cleanPhone = value.replace(/[^\d]/g, "");
                addLine(vcard, `TEL;TYPE=CELL:${cleanPhone}`);
                const waLink = `https://wa.me/${cleanPhone}`;
                notesArray.push(`WhatsApp: ${waLink}`);
                continue;
              }

              if (lowerPlatform === "email") {
                addLine(vcard, `EMAIL;TYPE=INTERNET:${escapeVCardValue(value)}`);
                continue;
              }

              if (lowerPlatform === "address") {
                addLine(vcard, `ADR;TYPE=WORK;CHARSET=UTF-8:;;${escapeVCardValue(value)};;;;`);
                continue;
              }

              const link = normalizeSocialLink(lowerPlatform, value);
              const label = socialPlatforms[lowerPlatform]?.label || platform;

              addLine(vcard, `item${itemIndex}.URL:${escapeVCardValue(link)}`);
              addLine(vcard, `item${itemIndex}.X-ABLabel:${escapeVCardValue(label)}`);
              addLine(vcard, `X-SOCIALPROFILE;TYPE=${lowerPlatform}:${escapeVCardValue(link)}`);
              
              notesArray.push(`${label}: ${link}`);
              itemIndex++;
            }
          }
        }

        if (notesArray.length) {
          addLine(vcard, `NOTE;CHARSET=UTF-8:${escapeVCardValue(notesArray.join("\n"))}`);
        }

        addLine(vcard, "END:VCARD");
        const vcardString = vcard.join("\r\n");
        const blob = new Blob([vcardString], { type: "text/vcard;charset=utf-8;" });
        const fileName = `${name.replace(/\s+/g, "_")}.vcf`;

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const dLink = document.createElement("a");
          const url = URL.createObjectURL(blob);
          dLink.href = url;
          dLink.download = fileName;
          dLink.style.display = "none";
          document.body.appendChild(dLink);
          dLink.click();
          document.body.removeChild(dLink);
          setTimeout(() => { URL.revokeObjectURL(url); }, 1000);
        }
      } catch (error) {
        console.error("خطا در ساخت فایل VCF:", error);
      } finally {
        this.vcfLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.view-holder {
  background-color: #979797;
}

.view-wrapper::-webkit-scrollbar {
  display: none;
}

#div1 {
  display: flex;
  justify-content: center;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  height: 28px;
  width: 40%;
  margin: -1px auto 8px;
  perspective: 100px;
  z-index: 2;
}

#div2 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: -3px;
  border-radius: 0 0 16px 16px;
  transform-style: preserve-3d;
  transform: rotateX(-46deg);
  z-index: 0;
  background-color: #979797;
}

.v-btn {
  text-transform: none;
  transition: transform 0.2s ease;
}
.v-btn:active {
  transform: scale(0.95);
}
.modern-footer-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 13;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.footer-gradient-overlay {
  height: 6px;
  background: linear-gradient(to top, white 40%, rgba(255, 255, 255, 0.026) 70%, transparent 100%);
  opacity: 0.15;
}

.footer-content {
  background: transparent; 
  pointer-events: none;
}

.footer-content > * {
  pointer-events: auto;
}

* {
  font-family: 'Vazir', Tahoma, sans-serif !important;
}

.bg-blur-layer {
  opacity: 0.15;     
  filter: blur(10px); 
}
 
.glass-effect {
  filter: brightness(1.4); 
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}
.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3); 
  backdrop-filter: blur(4px);
  z-index: 1;
}

</style>
